'use client'
import type { FC, ReactNode, Dispatch, SetStateAction } from 'react'
import { createContext, useContext, useEffect, useRef, useState } from 'react'
import { usePathname } from 'next/navigation'

type TypeSortBy = {
  name: string
  value: string
}

type TypeState = {
  filterQ: string
  sortBy: TypeSortBy
  filterBy: unknown
  setFilterQ: Dispatch<SetStateAction<string>>
  setSortBy: Dispatch<SetStateAction<TypeSortBy>>
  setFilterBy: Dispatch<SetStateAction<unknown>>
}

const initialState: TypeState = {
  filterQ: null,
  sortBy: null,
  filterBy: null,
  setFilterQ:  () => {},
  setSortBy:  () => {},
  setFilterBy: () => {}
}

export const FiltersContext = createContext<TypeState | null>(initialState)

interface Props {
  children: ReactNode
}

export const FiltersProvider: FC<Props> = ({ children }) => {
  const [filterQ, setFilterQ] = useState<string>(undefined)
  const [sortBy, setSortBy] = useState<TypeSortBy>(undefined)
  const [filterBy, setFilterBy] = useState<unknown>(undefined)

  return (
    <FiltersContext.Provider
      value={{
        filterQ,
        setFilterQ,
        sortBy,
        setSortBy,
        filterBy,
        setFilterBy
      }}
    >
      <FiltersManager />
      {children}
    </FiltersContext.Provider>
  )
}

function FiltersManager() {
  const pathname = usePathname()
  const ctx = useContext(FiltersContext)
  const lastPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    if (lastPathnameRef.current === pathname) return
    lastPathnameRef.current = pathname

    queueMicrotask(() => {
      ctx?.setFilterQ(undefined)
      ctx?.setFilterBy(undefined)
      ctx?.setSortBy(undefined)
    })
  }, [pathname, ctx])

  return null
}
